import { CreateSnapshotExportPayload, SnapshotExportFormat } from "@/modules/snapshots/businessReports.api";

export type SnapshotCollectionExportFormat = SnapshotExportFormat;

export const SNAPSHOT_COLLECTION_EXPORT_OPTIONS: Array<{
  format: SnapshotCollectionExportFormat;
  label: string;
}> = [
  { format: "xlsx", label: "XLS" },
  { format: "csv", label: "CSV" },
];

interface CanExportAllCollectionsParams {
  isFamilyCollection?: boolean;
  contractFamilyProjection?: boolean;
  snapshotViewId?: string;
}

// A Supplier Summary Collection shares its template with the base collection, so a
// template-wide export would put the base collection's supporting documents in the file.
export const canExportAllCollections = ({
  isFamilyCollection,
  contractFamilyProjection,
  snapshotViewId,
}: CanExportAllCollectionsParams): boolean => !snapshotViewId && !contractFamilyProjection && !isFamilyCollection;

export const getAllSnapshotCollectionsExportPayload = (
  businessReportId: string,
  format: SnapshotCollectionExportFormat,
): CreateSnapshotExportPayload => ({
  business_report_id: businessReportId,
  format,
});

interface GetSnapshotCollectionExportPayloadParams {
  snapshotCollectionId: string;
  businessReportId: string;
  format: SnapshotCollectionExportFormat;
  filteredOutcomeIds?: string[];
  subcollectionId?: string;
  contractFamilyProjection?: boolean;
}

export const getSnapshotCollectionExportPayload = ({
  snapshotCollectionId,
  businessReportId,
  format,
  filteredOutcomeIds,
  subcollectionId,
  contractFamilyProjection = false,
}: GetSnapshotCollectionExportPayloadParams): CreateSnapshotExportPayload => {
  const payload: CreateSnapshotExportPayload = {
    business_report_id: businessReportId,
    snapshot_collection_id: snapshotCollectionId,
    format,
  };

  if (contractFamilyProjection) {
    payload.contract_family_projection = true;
  }

  if (subcollectionId) {
    payload.subcollection_id = subcollectionId;
  }

  if (filteredOutcomeIds?.length) {
    payload.business_report_outcome_ids = filteredOutcomeIds;
  }

  return payload;
};

interface GetSnapshotCollectionExportLabelParams {
  collectionName: string;
  subcollectionName?: string;
  formatLabel: string;
  isFiltered: boolean;
}

export const getSnapshotCollectionExportLabel = ({
  collectionName,
  subcollectionName,
  formatLabel,
  isFiltered,
}: GetSnapshotCollectionExportLabelParams): string =>
  subcollectionName
    ? `Export sub-collection "${subcollectionName}"${isFiltered ? " filtered" : ""} to ${formatLabel}`
    : isFiltered
      ? `Export "${collectionName}" filtered to ${formatLabel}`
      : `Export "${collectionName}" to ${formatLabel}`;
